import React from 'react'
import LoginForm from '../components/LoginForm'

const LoginPage = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <LoginForm />
        </div>
    )
}

export default LoginPage